import { apiClient } from '@/utils/api-client';
import type {
  ManagementFeeSchedule,
  ManagementFeeScheduleCreate,
  ManagementFeeSchedulePage,
  ManagementFeeScheduleUpdate,
  ManagementFeeSettlement,
  ManagementFeeSummary,
} from '@/types/management-fees';

export const managementFeeService = {
  async list(
    fundId: string,
    params?: { is_active?: boolean; page?: number; page_size?: number }
  ): Promise<ManagementFeeSchedulePage> {
    return await apiClient.get(`/funds/${fundId}/management-fees`, { params });
  },

  async summary(fundId: string): Promise<ManagementFeeSummary> {
    return await apiClient.get(`/funds/${fundId}/management-fees/summary`);
  },

  async get(
    fundId: string,
    scheduleId: string
  ): Promise<ManagementFeeSchedule> {
    return await apiClient.get(
      `/funds/${fundId}/management-fees/${scheduleId}`
    );
  },

  async create(
    fundId: string,
    data: ManagementFeeScheduleCreate
  ): Promise<ManagementFeeSchedule> {
    return await apiClient.post(`/funds/${fundId}/management-fees`, data);
  },

  async update(
    fundId: string,
    scheduleId: string,
    data: ManagementFeeScheduleUpdate
  ): Promise<ManagementFeeSchedule> {
    return await apiClient.patch(
      `/funds/${fundId}/management-fees/${scheduleId}`,
      data
    );
  },

  async delete(fundId: string, scheduleId: string): Promise<void> {
    await apiClient.delete(`/funds/${fundId}/management-fees/${scheduleId}`);
  },

  async settleThrough(
    fundId: string,
    paymentId: string,
    settledThrough: ManagementFeeSettlement
  ): Promise<{ id: string }> {
    return await apiClient.put(
      `/funds/${fundId}/management-fees/payments/${paymentId}/settlement`,
      { settled_through: settledThrough }
    );
  },
};
